export const TOGGLE_DRAWER = 'TOGGLE_DRAWER'

export const toggleDrawer = toggle => {
  return {
    type: TOGGLE_DRAWER,
    drawer: toggle
  }
}
